export const clientCodeCheck = value => {
  const regExp = /^[Dd|Bb]\d{6}$/
  return regExp.test(String(value)) ? true : false
}

export const emailCheck = value => {
  const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regExp.test(String(value)) ? true : false
}